module.exports = __webpack_public_path__ + "img/wz-3-1.4ee53abd.jpg";